import { MODALS, EVENTS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';
import { LOANS } from 'loans.module/common/domain/constants.loans.js';
import { LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG } from 'loans.module/common/domain/constants.loans';

import { isUndefinedOrNullOrEmpty } from '../../../common/utils/isUndefinedOrNullOrEmpty';

class NeedALoanController {
  constructor(
    $state,
    $stateParams,
    $timeout,
    $window,
    $location,
    $log,
    $scope,
    $rootScope,
    $q,
    LoansUserDataService,
    loansStaticService,
    loansSignUpService,
    LoansOperationsService,
    LoansNeedALoanService,
    loadingMobileService,
    metricsService
  ) {
    'ngInject';
    this.state = $state;
    this.stateParams = $stateParams;
    this.timeout = $timeout;
    this.window = $window;
    this.location = $location;
    this.log = $log;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.q = $q;

    this.loansUserDataService = LoansUserDataService;
    this.loansStaticService = loansStaticService;
    this.loansSignUpService = loansSignUpService;
    this.loansOperationsService = LoansOperationsService;
    this.loansNeedALoanService = LoansNeedALoanService;
    this.loadingMobileService = loadingMobileService;
    this.metricsService = metricsService;

    this.BUY_HOUSING_PURPOSE = LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
    this.coachmarkData = LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG;
    this.userId = this.loansUserDataService._employee.userId;
    this.isMobileApp = $window.innerWidth < 1024;

    this.snapshotSimulation = this.loansNeedALoanService.getDataSimulation();

    if (this.stateParams.snapshot || this.snapshotSimulation) {
      this.initFromSnapshot();
    } else {
      this.init();
    }
  }

  $onInit() {
    this.rootScope.$broadcast(EVENTS.CHANGE_TITLE, {title: 'LOANS.NEED_A_LOAN.TITLE'});
  }

  initFromSnapshot() {
    this.loadingMobileService.show();
    this.loansOperationsService.getCreditworthiness(this.userId).then(creditworthiness => {
      this.creditworthiness = creditworthiness;
      this.housingWitness = this.creditworthiness.housingWitness;
      this.initSnapshot();
      this.loaded = true;
    }, error => {
      this.log.error('NeedALoanController initFromSnapshot()', error);
      // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
      // this.state.go(STATES.ERROR);
    }).finally(()=> {
      this.loadingMobileService.hide();
    });
  }

  initSnapshot() {

    // Prevail snapshot simulation over snapshot from stateparams, its always more recent
    const snapshot = this.snapshotSimulation || this.stateParams.snapshot;

    // Go back does not has the result loans cards: set it
    if (
      !snapshot.loanSimulationRequest &&
      this.snapshotSimulation &&
      (this.snapshotSimulation.loanSimulationRequest || this.snapshotSimulation.loanSimulation)
    ) {
      snapshot.loanSimulationRequest = this.snapshotSimulation.loanSimulationRequest || this.snapshotSimulation.loanSimulation;
    }

    this.loanSimulationRequest = {};
    this.loanSimulationRequest = (this.snapshotSimulation) ? snapshot.loanSimulationRequest : snapshot.loanSimulation;

    this.simulation = snapshot.simulation;
    this.itemSelected = snapshot.familySelected;
    this.codeLoanSimulation = snapshot.optionFamilySelected;
    this.selectedOptionFamily = true;
    this.families = snapshot.families;
    this.codeOptionSelected = snapshot.codeOptionSelected;
    this.optionsFamiliesToSelect = snapshot.optionsFamiliesToSelect;

    if (this.isMobileApp)
      this.formatFamiliesOnMobileApp(this.families);

    this.scrollToResults();
  }

  init() {
    this.loadingMobileService.show();
    this.q.all([
      this.loansOperationsService.getCreditworthiness(this.userId),
      this.loansOperationsService.getFamilies()
    ]).then(responses => {
      this.creditworthiness = responses[0];
      this.families = responses[1].data.needALoanFamiliesList;
      if (this.isMobileApp)
        this.formatFamiliesOnMobileApp(responses[1].data.needALoanFamiliesList);
      this.loaded = true;
      this.housingWitness = this.creditworthiness.housingWitness;
      this.simulationWitness = this.creditworthiness.simulationWitness;
    }, error => {
      this.log.error('NeedALoanController init()', error);
      // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
      // this.state.go(STATES.ERROR);
    }).finally(()=> {
      this.loadingMobileService.hide();
    });
  }

  $onDestroy() {
    this.resetAllSimulation();
  }

  get modal() {
    const $modal = $(MODALS.NEED_A_LOAN);
    return $modal;
  }

  showLoading() {
    return !this.isMobileApp && !this.loaded;
  }

  formatFamiliesOnMobileApp(families) {
    const keysFamilies = Object.keys(families);
    this.familiesOnMobileApp = keysFamilies.map(fam => {
      return {
        value: fam,
        option: families[fam].literal,
      };
    });
  }

  getLoan(loanId) {
    return this.loansStaticService.get(loanId);
  }

  getClasses() {
    return {
      'remove-events': this.serviceClosed,
      responsiveMobile: this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp,
    };
  }

  selectFamily($event) {
    if (this.itemSelected !== $event.fam) {
      this.itemSelected = null;
    }

    this.codeLoanSimulation = null;
    this.loanSimulationRequest = undefined;
    this.simulation = undefined;
    this.itemSelected = $event.fam;
    this.selectedOptionFamily = false;
    this.optionsFamiliesToSelect = undefined;
    this.codeOptionSelected = undefined;
    this.getCategoriesWithFamily();
  }

  getCategoriesWithFamily() {
    const familyPurposes = this.families[this.itemSelected].purposes;
    this.optionsFamiliesToSelect = familyPurposes.map(purpose => {
      return {
        value: purpose.purposeCode,
        option: purpose.purposeLiteral,
      };
    });
  }

  onSelectOptionFamily($event) {
    this.selectedOptionFamily = false;
    this.timeout(() => {
      this.simulation = undefined;
      this.codeLoanSimulation = $event.codeLoanSimulation;
      this.codeOptionSelected = $event.codeOptionSelected;
      this.selectedOptionFamily = true;
      this.loanSimulationRequest = undefined;
    });
  }

  setSimulation($event) {
    this.loanSimulationRequest = undefined;
    this.resetLocationHash();
    this.simulation = $event;
    const simulationEndpoint = this._buildEndpointSimulation(this.simulation);
    const codeOptionIsHousingPurpose = this.codeOptionSelected === this.BUY_HOUSING_PURPOSE;

    this.loadingMobileService.show();
    this.loansSignUpService.createSimulation(this.userId, simulationEndpoint).then(response => {

      this.loanSimulationRequest = this.filterSimulation(response, codeOptionIsHousingPurpose);
      this.loanSimulationRequest.simulation = this.simulation;
      this.scrollToResults();
      const snapshot = this.createSnapshot();

      this.log.info('Snapshot created after simulation:', snapshot);
      this.loansNeedALoanService.setDataSimulation(snapshot);

      if (this.isMobileApp) {
        this.metricsService.trackLoansSimulation();
        this.state.go(STATES.LOANS.NEED_A_LOAN_RESULTS, {snapshot});
      }
    }, response => {

      this.cleanPreviousSimulation();
      this.errorMessage = response.data.message;
      this.presentCannotSignUpModal(true);

    }).finally(()=> this.loadingMobileService.hide());
  }

  filterSimulation(simulation, isHousingPurpose) {
    return simulation.data.simulations.filter(loanSimulation => {
      this.setInfo(loanSimulation);
      if (isHousingPurpose) {
        return loanSimulation.loanId !== LOANS.ID_HR.VARIOUS_CREDIT;
      }
      return true;
    });
  }

  createSnapshot() {
    const snapshot = {
      loanSimulation: this.loanSimulationRequest,
      loanSimulationRequest: this.loanSimulationRequest,
      familySelected: this.itemSelected,
      optionFamilySelected: this.codeLoanSimulation,
      families: this.families,
      codeOptionSelected: this.codeOptionSelected,
      creditworthiness: this.creditworthiness,
      simulation: this.simulation,
      optionsFamiliesToSelect: this.optionsFamiliesToSelect
    };
    return snapshot;
  }

  setInfo(loanSimulation) {
    const loan = this.getLoan(loanSimulation.loanId);
    loanSimulation.title = this.loansStaticService.get(loanSimulation.loanId).title;
    this.setTitleFixedVariable(loanSimulation);
    loanSimulation.id = loan.id;
  }

  setTitleFixedVariable(loanSimulation) {
    const loanId = loanSimulation.loanId;
    let newTitle  = loanSimulation.title;
    if(loanId === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN || loanId === LOANS.ID_HR.SOCIAL_HOUSING_LOAN){
      newTitle += (loanSimulation.typeFixedVariable === '1')? '_FIXED' : '_VARIABLE';
    }
    loanSimulation.newTitle = newTitle;
  }

  cleanPreviousSimulation() {
    this.loanSimulationRequest = null;
  }

  _buildEndpointSimulation(amountSimulation) {
    const endpointSimulation = {
      loanPurposeId: this.codeOptionSelected,
      amount: amountSimulation.amount,
      wantInsurance: amountSimulation.wantInsurance,
      typeFixedVariable: amountSimulation.typeFixedVariable || '0',
      isSimulation: amountSimulation.isSimulation || false
    };

    if (!isUndefinedOrNullOrEmpty(amountSimulation.fixedFeeNumber)) {
      endpointSimulation.deadline = parseInt(amountSimulation.fixedFeeNumber, 10);
    }

    if (!isUndefinedOrNullOrEmpty(amountSimulation.monthlyFeeAmount)) {
      endpointSimulation.monthlyAmount = amountSimulation.monthlyFeeAmount;
    }

    if (this.codeOptionSelected === this.BUY_HOUSING_PURPOSE) {
      endpointSimulation.acquisitionCost =
        amountSimulation.acquisitionCost != null
          ? amountSimulation.acquisitionCost
          : amountSimulation.diff;

      if (!isUndefinedOrNullOrEmpty(amountSimulation.salePrice)) {
        endpointSimulation.salePrice = amountSimulation.salePrice;
      }

    } else {
      delete endpointSimulation.acquisitionCost;
      delete endpointSimulation.salePrice;
    }

    return endpointSimulation;
  }

  onOptionSelect($event) {
    this.selectedOptionFamily = false;
    this.resetAllSimulation();
    this.timeout(() => {
      this.itemSelected = $event.familyName;
      this.codeOptionSelected = $event.purposeCode;
      this.codeLoanSimulation = `${$event.purposeCode}${$event.familyCode}`;
      this.selectedOptionFamily = true;
      this.getCategoriesWithFamily();
    });
  }

  presentCannotSignUpModal(reason) {
    this.cannotSignUpError = reason;
    this.modal.modal('show');
  }

  goMyLoans() {
    this.modal.modal('hide');
    this.state.go(STATES.LOANS.MY_LOANS);
  }

  scrollToResults() {
    this.location.hash('request-card-simulation');
  }

  resetLocationHash() {
    this.location.hash('');
  }

  getCodeLoan() {
    return this.codeOptionSelected === this.BUY_HOUSING_PURPOSE;
  }

  resetAllSimulation() {
    this.selectedOptionFamily = false;
    this.itemSelected = undefined;
    this.loanSimulationRequest = undefined;
    this.codeOptionSelected = null;
    this.codeLoanSimulation = undefined;
    this.simulation = {};
    this.window.scrollTo(0, 0);
    this.loansNeedALoanService.clearAllDataSimulation();
  }
}

export default NeedALoanController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoan.controller.js